export default __webpack_public_path__ + "static/image-31-88664eb872481e74b7089ae194896b09.jpg";